import { useState, useEffect, useRef } from 'react';
import { TREE_CONFIG } from '@/config';

interface Dimensions {
  width: number;
  height: number;
  padding: number;
}

export function useTreeDimensions(): Dimensions {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [dimensions, setDimensions] = useState<Dimensions>({
    width: window.innerWidth,
    height: Math.max(500, window.innerHeight - 200),
    padding: TREE_CONFIG.INITIAL_PADDING
  });

  useEffect(() => {
    const container = document.querySelector('.tree-container') as HTMLDivElement;
    if (container) {
      containerRef.current = container;
    }

    const updateDimensions = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        setDimensions({
          width: rect.width,
          height: Math.max(500, rect.height),
          padding: TREE_CONFIG.INITIAL_PADDING
        });
      }
    };

    // Initial update
    updateDimensions();

    // Create ResizeObserver
    const observer = new ResizeObserver(updateDimensions);
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    // Handle window resize
    window.addEventListener('resize', updateDimensions);

    return () => {
      window.removeEventListener('resize', updateDimensions);
      observer.disconnect();
    };
  }, []);

  return dimensions;
}